import React, { useContext } from 'react'
import Space from '../atoms/Space'
import { View } from '../other/html'
import ListLeftColumn from './item/ListLeftColumn'
import { ItemContext, ItemDispatchContext } from 'src/contexts/itemContext'
import InRealizationPriceColumn from './item/InRealizationPriceColumn'
import ExpandedAccepted from './item/ExpandedAccepted'

const RealizationItem = (): JSX.Element => {
  const itemContext = useContext(ItemContext)
  const dispatchItemContext = useContext(ItemDispatchContext)

  if (itemContext === null || dispatchItemContext === null) {
    throw new Error('itemContext must be used within a ItemProvider')
  }

  const { index, expandedView } = itemContext
  const backgroundColor = (i: number): string => (i % 2 === 0 ? 'bg-lightGrey' : 'bg-white')
  const radiusStyles = expandedView ? 'rounded-b-4 rounded-t-2' : 'rounded-2'
  const cursorStyles = expandedView ? 'cursor-default' : 'cursor-pointer'
  return (
    <View
      data-testid="realization-item"
      className={`shadow-bothSmall mb-4 ${backgroundColor(index)} ${radiusStyles} ${cursorStyles}`}
      onClick={() => {
        dispatchItemContext({ type: 'EXPAND_VIEW' })
      }}>
      <Space y={2} />
      <View className="flex justify-between">
        <ListLeftColumn />
        <InRealizationPriceColumn />
      </View>
      <Space y={2} />
      <ExpandedAccepted variant="realization" expandedView={expandedView} />
    </View>
  )
}

export default React.memo(RealizationItem)
